import type { TiptapEditorPlugin } from 'ricos-types';

import { selection } from './extension';

export const pluginSelection: TiptapEditorPlugin = {
  type: 'SELECTION',
  config: {},
  tiptapExtensions: [selection],
};
